const crypto = require('crypto')
const salt = '5u?3r#456s@!t'

export default function (email, password) {
  // should be createHmac
  let hash = crypto.createHash('sha512', salt)
  hash.update(password)

  return hash.digest('hex')
}
